const API_URL = "https://api.1stopvat.com/api";
//const API_URL = "https://test-api.1stopvat.com/api";
const GET_ME = "/auth/me";
const GET_COUNTRIES = "/countries";
const GET_VAT_COUNTRIES = "/countries/vat";
const GET_VAT_HISTORY_COUNTRIES = "/admin/vat-rates/countries";
const GET_VAT_HISTORY = "/admin/vat-rates/history/"; // {EU/REST/CA}/{country_id} | GET POST
export const GET_VAT_HISTORY_NAME = "/admin/vat-rates/tax-name/history/"; // {EU/REST/CA} | GET POST
const GET_ALL_COUNTRIES = "/countries/all";
const GET_ALL_REGIONS = "/countries/regions";
const GET_ALL_MARKET_PLACES = "/countries/market-places";
const GET_TRESHOLDS = "/tresholds";
const GET_SALES_REPORT = "/sales-report";
const GET_SALES_REPORT_COUNTRIES = "/sales-report/countries";
const GET_SALES_REPORT_DETALIZATION = "/sales-report/detalization";
const GET_SALES_REPORT_DONUT = "/sales-report/widget";
const GET_TRANSACTIONS = "/transactions";
const GET_PURCHASES = "/purchases";
const GET_NOTIFICATIONS_MENU = "/notification/menu";
const GET_NOTIFICATIONS = "/notifications";
const GET_TRANSACTIONS_FILTERS = "/transactions/filters";
const GET_TRANSACTIONS_MODAL = "/transactions/";
const GET_TRANSACTIONS_EXCEL_FILE = "/export/transactions";
const GET_INTEGRATION_DATA_STATUS = "/data/status";
const GET_DOWNLOAD_FILE = "/file/download/"; //{file-id}
const GET_USER_RETURN_CALENDAR_TABLE = "/returns/calendar";

const GET_ADMIN_RATES = "/admin/rates/";
const GET_ADMIN_VAT_RATES = "/admin/vat-rates/"; //{region}
const GET_ADMIN_RECEIVED_FILES = "/import/received-files";
const GET_ADMIN_IMPORTED_FILES = "/import/imported-files"; 
const GET_ADMIN_EXPORTED_FILES = "/import/export-files"; 
const GET_ADMIN_IMPORT_FILE_STATUS = "/import/check-file-status";
const GET_ADMIN_IMPORT_FILE = "/uploaded/";
const GET_ADMIN_FILES_RETURN_TABLE = "/returns"
const GET_ADMIN_RETURNS_FOR_PERIOD = "/user/returns/"; //{id}
const POST_ADMIN_IMPORT_FILE_STATE_ACTION= "/import/export-files/"; //{id}/cancel
const POST_ADMIN_VAT_RATES = "/admin/vat-rates/"; // {region}/{id}/
const POST_ADMIN_FILE_UPLOAD = "/import/file";


const POST_ME = "/user";
const POST_ME_ADMIN = "/auth/me/main";
const POST_NOTIFICATIONS_SEEN = "/notifications/"; //{id}/seen
// const POST_THRESHOLDS = "/thresholds/"; //{id}
const POST_USER_FILES_RETURN_TABLE = "/import/country-returns"
const POST_CONTACT_US = '/email/contact-us/';
const POST_TRESHOLD_ORDERS = '/orders';
const POST_USER_NEW_PASS = "/user/change-password";
const POST_ADMIN_NEW_PASS = "/user/main/change-password";
const POST_USER_NEW_EMAIL = "/user/change-email";
const POST_ADMIN_NEW_EMAIL = "/user/main/change-email";
const POST_USER_REGISTER_TYPE_ONE = "/register";
const POST_USER_REGISTER_TYPE_TWO = "/register";
const POST_USER_EMAIL_EXIST = "/register/check-email";
const POST_USER_LOGIN = "/auth/login";
export const POST_USER_REMIND_PASSWORD = "/auth/remind-password";
const POST_ADMIN_CURRENT_COMPANY = '/user/change-company'
const POST_GET_INTEGRATIONS = "/integrations";
const POST_VAT_PERIOD = "/user/vat";
const POST_VAT_NUMBER_ID = "/vat-registration/";
const POST_NOTIFICATIONS_ALL_READ = "/notifications/all-seen";


const MINIMUM_PASSWORD_LENGTH = 6;
const MAXIMUM_PASSWORD_LENGTH = 100;

const FORM_FIELDS_USER_ONE = {
  email: {
    name: `email`,
    placeholder: `Email address`,
    type: `email`,
    required: true,
    content: [
      {
        name: "value0",
        value: "value0",
      },
    ]
  },
  companyName: {
    name: `companyName`,
    placeholder: `Enter company name`,
    type: `companyName`,
    required: true,
    content: [
      {
        name: "value0",
        value: "value0",
      },
    ]
  },
  contactEmail: {
    name: `contactEmail`,
    placeholder: `Enter contact email`,
    type: `contactEmail`,
    required: true,
    content: [
      {
        name: "value0",
        value: "value0",
      },
    ]
  },
  digitalGoods: {
    name: `digitalGoods`,
    placeholder: `Select product type`,
    type: `select`,
    required: true,
    content: [
      {
        name: "Digital goods",
        value: 1001,
      },
      {
        name: "Digital goods (e-books)",
        value: 1002,
      },
      {
        name: "Distance sale",
        value: 2001,
      },
      {
        name: "Distance sale (Books)",
        value: 2002,
      },
    ],
  },
  vatIncluded: {
    name: `vatIncluded`,
    placeholder: `Select pricing type`,
    type: `select`,
    required: true,
    content: [
      {
        name: "VAT inclusive",
        value: 1,
      },
      {
        name: "VAT exclusive",
        value: 0,
      }
    ],
  },
  countryOfDispatch: {
    name: `countryOfDispatch`,
    placeholder: `Country of dispatch`,
    tel: true,
    required: true,
    content: [
      {
        name: "Belgium",
        value: "BE",
      },
      {
        name: "Bulgaria",
        value: "BG",
      },
      {
        name: "Czechia",
        value: "CZ",
      },
      {
        name: "Denmark",
        value: "DK",
      },
      {
        name: "Germany",
        value: "DE",
      },
      {
        name: "Estonia",
        value: "EE",
      },
      {
        name: "Ireland",
        value: "IE",
      },
      {
        name: "Greece",
        value: "GR",
      },
      {
        name: "Spain",
        value: "GB",
      },
      {
        name: "Spain",
        value: "ES",
      },
      {
        name: "France",
        value: "FR",
      },
      {
        name: "Croatia",
        value: "HR",
      },
      {
        name: "Italy",
        value: "IT",
      },
      {
        name: "Cyprus",
        value: "CY",
      },
      {
        name: "Latvia",
        value: "LV",
      },
      {
        name: "Lithuania",
        value: "LT",
      },
      {
        name: "Luxembourg",
        value: "LU",
      },
      {
        name: "Hungary",
        value: "HU",
      },
      {
        name: "Malta",
        value: "MT",
      },
      {
        name: "Netherlands",
        value: "NL",
      },
      {
        name: "Austria",
        value: "AT",
      },
      {
        name: "Poland",
        value: "PL",
      },
      {
        name: "Portugal",
        value: "PT",
      },
      {
        name: "Romania",
        value: "RO",
      },
      {
        name: "Slovenia",
        value: "SI",
      },
      {
        name: "Slovakia",
        value: "SK",
      },
      {
        name: "Finland",
        value: "FI",
      },
      {
        name: "Sweden",
        value: "SE",
      },
    ],
  },
};

const FORM_FIELDS_INTEGRATION_AMAZON = {
  digitalGoods: {
    name: `digital_goods`,
    placeholder: `Select product type`,
    type: `select`,
    required: true,
    content: [
      {
        name: "Digital goods",
        value: 1001,
      },
      {
        name: "Digital goods (e-books)",
        value: 1002,
      },
      {
        name: "Distance sale",
        value: 2001,
      },
      {
        name: "Distance sale (Books)",
        value: 2002,
      },
    ],
  },
  seller_id: {
    name: "seller_id",
    title: "Amazon Seller ID",
  },

  amazon_city: {
    name: "amazon_city",
    title: "City / State",
    placeholder: "Enter name",
  },

  amazon_address: {
    name: "amazon_address",
    title: "Address",
    placeholder: "Enter address",
  },

  amazon_zip: {
    name: "amazon_zip",
    title: "Zip / Postal code",
    placeholder: "Enter code",
  },
  amazon_mws_auth_token: {
    name: "amazon_mws_auth_token",
    title: "MWS auth token",
  },
  region: {
    name: "region",
    title: "Region",
    placeholder: `Select Country of Disaptch`,
    values: [
      {
        name: 'America',
        value: 'america'
      },
      {
        name: 'Europe',
        value: 'europe'
      },
      {
        name: 'India',
        value: 'india'
      },
      {
        name: 'United Arab Emirates (E.A.U)',
        value: 'emirates'
      },
      {
        name: 'Singapore',
        value: 'singapore'
      },
      {
        name: 'Australia',
        value: 'australia'
      },
      {
        name: 'Japan',
        value: 'japan'
      },
    ]
  },
  amazon_marketplaces: {
    name: "amazon_marketplaces",
    title: "MarketPlaces",
    values: [
      {
        name: 'Brazil',
        value: 'BRA'
      },
      {
        name: 'Canada',
        value: 'CA'
      },
      {
        name: 'Mexico',
        value: 'MEX'
      },
      {
        name: 'US',
        value: 'US'
      },
    ]
    
  },
  amazon_fba: {
    name: "amazon_fba",
    title: "Are you using FBA?",
  },
  amazon_country_of_dispatch: {
    name: "amazon_country_of_dispatch",
    title: "Default country of dispatch",
  },
  historical_date: {
    name: "historical_date",
    title: "Historical Data",
    subtitle: "(max 17 months ListFinancialEvents)",
  }
}


const FORM_FIELDS_USER_TWO = {
  email: {
    name: `email`,
    placeholder: `Email`,
    type: `text`,
    required: true,
  },
  password: {
    name: `password`,
    placeholder: `Password`,
    type: `password`,
    required: true,
  },
  passwordrepeat: {
    name: `passwordrepeat`,
    placeholder: `Repeat Password`,
    type: `password`,
    required: true,
  },
  companyname: {
    name: `name`,
    title: `Company legal name *`,
    type: `text`,
    required: true,
  },
  companycode: {
    name: `code`,
    title: `Company code *`,
    type: `text`,
    required: true,
  },
  countryincorporation: {
    name: `country_of_incorporation`,
    title: 'Country of incorporation',
    placeholder: `Select`,
    type: `select`,
    required: true,
    content: [],
  },
  accountingcurrency: {
    name: `accounting_currency`,
    title: 'Accounting currency *',
    placeholder: `Select`,
    type: `select`,
    required: true,
    content: [
      {
        name: "EUR",
        value: "EUR",
      },
      {
        name: "USD",
        value: "USD",
      },
      {
        name: "GBP",
        value: "GBP",
      },
    ],
  },
  pricingType: {
    name: `vatIncluded`,
    title: 'Pricing type *',
    placeholder: `Select pricing type`,
    type: `select`,
    required: true,
    content: [
      {
        name: "VAT inclusive",
        value: 1,
      },
      {
        name: "VAT exclusive",
        value: 0,
      }
    ],
  },
  defaultProduct: {
    name: `digitalGoods`,
    title: `Default product *`,
    placeholder: `Select product type`,
    type: `select`,
    required: true,
    content: [
      {
        name: "Digital goods",
        value: 1001,
      },
      {
        name: "Digital goods (e-books)",
        value: 1002,
      },
      {
        name: "Distance sale",
        value: 2001,
      },
      {
        name: "Distance sale (Books)",
        value: 2002,
      },
    ],
  },
  countryOfDispatch: {
    name: `countryOfDispatch`,
    title: `Default country of dispatch`,
    placeholder: `Country of Dispatch`,
    required: false,
    content: [
      {
        name: "Belgium",
        value: "BE",
      },
      {
        name: "Bulgaria",
        value: "BG",
      },
      {
        name: "Czechia",
        value: "CZ",
      },
      {
        name: "Denmark",
        value: "DK",
      },
      {
        name: "Germany",
        value: "DE",
      },
      {
        name: "Estonia",
        value: "EE",
      },
      {
        name: "Ireland",
        value: "IE",
      },
      {
        name: "Greece",
        value: "GR",
      },
      {
        name: "Spain",
        value: "GB",
      },
      {
        name: "Spain",
        value: "ES",
      },
      {
        name: "France",
        value: "FR",
      },
      {
        name: "Croatia",
        value: "HR",
      },
      {
        name: "Italy",
        value: "IT",
      },
      {
        name: "Cyprus",
        value: "CY",
      },
      {
        name: "Latvia",
        value: "LV",
      },
      {
        name: "Lithuania",
        value: "LT",
      },
      {
        name: "Luxembourg",
        value: "LU",
      },
      {
        name: "Hungary",
        value: "HU",
      },
      {
        name: "Malta",
        value: "MT",
      },
      {
        name: "Netherlands",
        value: "NL",
      },
      {
        name: "Austria",
        value: "AT",
      },
      {
        name: "Poland",
        value: "PL",
      },
      {
        name: "Portugal",
        value: "PT",
      },
      {
        name: "Romania",
        value: "RO",
      },
      {
        name: "Slovenia",
        value: "SI",
      },
      {
        name: "Slovakia",
        value: "SK",
      },
      {
        name: "Finland",
        value: "FI",
      },
      {
        name: "Sweden",
        value: "SE",
      },
    ],
  },
  city: {
    name: `city`,
    title: `City / Region *`,
    type: `text`,
    required: true,
  },
  zip: {
    name: `zip`,
    title: `ZIP / Postal code *`,
    type: `text`,
    required: true,
  },
  address: {
    name: `address`,
    title: `Address *`,
    type: `text`,
    required: true,
  },
  contactname: {
    name: `contact_name`,
    title: `Contact name *`,
    type: `text`,
    required: true,
  },
  phone: {
    name: `phone_number`,
    title: `Phone number *`,
    subtitle: `(country code required)`,
    type: `text`,
    required: true,
  },
  emailprimary: {
    name: `primary_email_address`,
    title: `Primary email address *`,
    type: `text`,
    required: true,
  },
  emailsecondary: {
    name: `secondary_email_address`,
    title: `Secondary email address`,
    type: `text`,
    required: false,
  },
};

const CURRENCY_SELECT = [
  {
    name: "EUR",
    value: "EUR",
    symbol: "€",
  },
  {
    name: "USD",
    value: "USD",
    symbol: "$"
  },
  {
    name: "GBP",
    value: "GBP",
    symbol: "£",
  },
]

// Get Names for Continent Codes
const CONTINENTS = {
  EUR: "European Union",
  CA: "Canada",
  US: "United States",
  REST: "Rest of World",
};

/**
 *
 *    salesDetalizaiton
 *
 */

// filter values
const filterSalesTypeValues = {
  filtertype: "filterSalesType",
  filterItems: [
    {
      name: "Sales & Refunds",
      value: "salesrefunds",
    },
    {
      name: "Value 2",
      value: "value2",
    },
    {
      name: "Value 3",
      value: "value3",
    },
  ],
};

const filterBusinessTypeValues = {
  filtertype: "filterBusinessType",
  filterItems: [
    {
      name: "B2C Only",
      value: "b2c",
    },
    {
      name: "Value 2",
      value: "value2",
    },
    {
      name: "Value 3",
      value: "value3",
    },
  ],
};

const filterRegionTypeValues = {
  filtertype: "filterRegionType",
  filterItems: [
    {
      name: "All regions",
      value: "all",
    },
    {
      name: "Value 2",
      value: "value2",
    },
    {
      name: "Value 3",
      value: "value3",
    },
  ],
};

const FILTER_COUNTRY_SELECTION = [
  {
    label: 'All regions',
    value: 'all'
  },
  {
    label: 'US Only',
    value: 'us'
  },
  // {
  //   label: ' Canada Only',
  //   value: 'ca'
  // },
  {
    label: 'EU only',
    value: 'eu'
  },
  {
    label: 'Rest of world',
    value: 'rest'
  },
]

const FILTER_COUNTRY_SALES_DETALIZATION = [
  {
    label: 'All',
    value: 'all'
  },
  {
    label: 'US',
    value: 'us'
  },
  {
    label: 'Europe',
    value: 'eu'
  },
  {
    label: 'Canada',
    value: 'ca'
  },
  {
    label: 'Rest Of World',
    value: 'rest'
  },
]

const ADMIN_MENU = {
  userTypeTwoMenu: [
    {
      name: "Dashboard",
      id: "dashboard",
    },
    {
      name: "Sales detalization",
      id: "salesdetalization",
    },
    {
      name: "Vat registrations",
      id: "vatreg",
    },
    {
      name: "Tresholds",
      id: "tresholds",
    },
    {
      name: "Orders",
      id: "orders",
    },
    {
      name: "Returns",
      id: "returnsadmintable",
    },
    {
      name: "Calendar",
      id: "returnsusercalendar",
    },
    {
      name: "Files",
      id: "adminfileimport",
    },
  ],
  userTypeOneMenu: [
    {
      name: "Profile",
      adminName: "Client profile",
      id: "profile",
    },
    // {
    //   name: "Integrations",
    //   id: "integrations",
    // },
    {
      name: "Settings",
      adminName: "Client settings",
      id: "settings",
    },
  ],
};

// Dashboard
// Sales report
// VAT registrations
// Thresholds
// Returns
// Returns calendar
// Import files
// Integrations

// Dashboard menu
const DASHBOARD_MENU = {
  userTypeOneMenu: [
    {
      name: "Dashboard",
      id: "dashboard",
    },
    {
      name: "Sales report",
      id: "salesreport",
    },
    {
      name: "Sales detalization",
      id: "salesdetalization",
    },
    {
      name: "Vat registrations",
      id: "vatreg",
    },
    {
      name: "Tresholds",
      id: "tresholds",
    },
    {
      name: "Returns",
      id: "returnsusertable",
    },
    {
      name: "Returns calendar",
      id: "returnsusercalendar",
    },
    {
      name: "File import",
      id: "userfileimport",
    },
    
    // {
    //   name: "Integrations",
    //   id: "integrations",
    // },
  ]
}

// const DASHBOARD_MENU = {
//   userTypeTwoMenu: [
//     {
//       name: "Integrations",
//       id: "integrations",
//     },
//     {
//       name: "Documentation",
//       id: "documentation",
//     },
//     {
//       name: "API log",
//       id: "apilog",
//     },
//     {
//       name: "Administrate Vat Rates",
//       id: "adminvatrates",
//     },
//     {
//       name: "Profile",
//       adminName: "User profile",
//       id: "profile",
//     },
//     {
//       name: "Settings",
//       adminName: "User settings",
//       id: "settings",
//     },
//     {
//       name: "File import",
//       id: "adminfileimport",
//     },
//     {
//       name: "Returns calendar",
//       id: "returnsusercalendar",
//     },
//     {
//       name: "Returns (Admin)",
//       id: "returnsadmintable",
//     },
//     {
//       name: "Returns",
//       id: "returnsusertable",
//     },
//     {
//       name: "File import",
//       id: "userfileimport",
//     },
//   ],
//   userTypeOneMenu: [
//     {
//       name: "Vat registrations",
//       id: "vatreg",
//     },
//     {
//       name: "Dashboard",
//       id: "dashboard",
//     },
//     {
//       name: "Tresholds",
//       id: "tresholds",
//     },
//     {
//       name: "Sales report",
//       id: "salesreport",
//     },
//     {
//       name: "Sales detalization",
//       id: "salesdetalization",
//     },
//   ],
// };

const USER_MENU_ITEMS = [
  {
    id: "profile",
    name: "Profile",
  },
  // {
  //   id: "vatreg",
  //   name: "VAT registrations",
  // },
  {
    name: "Sales detalization",
    id: "salesdetalization",
  },
  // {
  //   name: "Edit VAT rates",
  //   id: "adminvatrates",
  // },
  {
    name: "Edit VAT rates",
    id: "historicalvatrates",
  },
  {
    name: "Currency rates",
    id: "admincurrencyrates",
  },
  {
    id: "settings",
    name: "Settings",
  },
  {
    id: "adminsettings",
    name: "Settings",
  },
  {
    id: "billing",
    name: "Billing",
  },
];

const FAKE_PROVIDERS = [
  {
    type: "amazon",
    enabled: true,
    link: "amazon",
  },
  // {
  //   type: "paypal",
  //   enabled: false,
  //   link: "#",
  // },
  // {
  //   type: "shopify",
  //   enabled: false,
  //   link: "#",
  // },
  // {
  //   type: "adyen",
  //   enabled: false,
  //   link: "#",
  // },
  // {
  //   type: "stripe",
  //   enabled: false,
  //   link: "#",
  // },
  // {
  //   type: "braintree",
  //   enabled: false,
  //   link: "#",
  // },
  // {
  //   type: "api",
  //   enabled: false,
  //   link: "#",
  // },
  // {
  //   type: "ebay",
  //   enabled: false,
  //   link: "#",
  // },
  // {
  //   type: "magento",
  //   enabled: false,
  //   link: "#",
  // },
  // {
  //   type: "woocommerce",
  //   enabled: false,
  //   link: "#",
  // },
];

const FAKE_INTEGRATION_DATA = [
  {
    source: "paypal",
    account_name: "test@testdomain.com",
    integration_date: "2020-12-31 16:51:58",
    date: "2020-09-12",
  },
  {
    source: "amazon",
    account_name: "test@testdomain.com",
    integration_date: "2020-12-31 16:51:58",
    date: "2020-09-12",
  },
  {
    source: "shopify",
    account_name: "test@testdomain.com",
    integration_date: "2020-12-31 16:51:58",
    date: "2020-09-12",
  },
  {
    source: "adyen",
    account_name: "test@testdomain.com",
    integration_date: "2020-12-31 16:51:58",
    date: "2020-09-12",
  },
  {
    source: "braintree",
    account_name: "test@testdomain.com",
    integration_date: "2020-12-31 16:51:58",
    date: "2020-09-12",
  },
  {
    source: "api",
    account_name: "test@testdomain.com",
    integration_date: "2020-12-31 16:51:58",
    date: "2020-09-12",
  },
  {
    source: "ebay",
    account_name: "test@testdomain.com",
    integration_date: "2020-12-31 16:51:58",
    date: "2020-09-12",
  },
  {
    source: "magento",
    account_name: "test@testdomain.com",
    integration_date: "2020-12-31 16:51:58",
    date: "2020-09-12",
  },
  {
    source: "woocommerce",
    account_name: "test@testdomain.com",
    integration_date: "2020-12-31 16:51:58",
    date: "2020-09-12",
  },
  {
    source: "amazon",
    account_name: "test@testdomain.com",
    integration_date: "2020-12-31 16:51:58",
    date: "2020-09-12",
  },
  {
    source: "magento",
    account_name: "test@testdomain.com",
    integration_date: "2020-12-31 16:51:58",
    date: "2020-09-12",
  },
]

const SALES_DETALIZATION_COLUMNS = [
  {
    Header: "",
    accessor: "img",
  },
  {
    Header: "Region",
    accessor: "region",
  },
  {
    Header: "NET Value",
    accessor: "netvalue",
  },
  {
    Header: "",
    accessor: "vat_message",
  },
  {
    Header: "VAT rate",
    accessor: "vatrate",
  },
  {
    Header: "VAT on sales",
    accessor: "vatonsales",
  },
  {
    Header: "GROSS value",
    accessor: "grossvalue",
  },
];


const FAKE_USER_VAT_REGISTRATIONS_DATA = [
  {
    country: "Germany",
    vat: "",
    reg_date: "2020-12-25",
    dereg_date: "2021-12-25",
    img: "http://138.68.85.246/storage/flags/US.png",
  },
  {
    country: "Italy",
    vat: "IT581524528521",
    reg_date: "2020-12-25",
    dereg_date: "",
    img: "http://138.68.85.246/storage/flags/CA.png",
  }
]

const DAY_SELECT = [
  {
    name: "Last 7 days",
    days: 7,
  },
  {
    name: "Last 14 days",
    days: 14,
  },
  {
    name: "Last 30 days",
    days: 30,
  },
  {
    name: "Current month",
    days: 'current',
  },
  {
    name: "Last month",
    days: 'last',
  },
];

export {
  API_URL,
  GET_ME,
  GET_COUNTRIES,
  GET_VAT_COUNTRIES,
  GET_VAT_HISTORY,
  GET_VAT_HISTORY_COUNTRIES,
  GET_ALL_COUNTRIES,
  GET_TRESHOLDS,
  GET_SALES_REPORT,
  GET_NOTIFICATIONS_MENU,
  GET_TRANSACTIONS,
  GET_PURCHASES,
  GET_TRANSACTIONS_FILTERS,
  GET_TRANSACTIONS_MODAL,
  GET_TRANSACTIONS_EXCEL_FILE,
  GET_SALES_REPORT_DETALIZATION,
  GET_SALES_REPORT_COUNTRIES,
  GET_SALES_REPORT_DONUT,
  GET_INTEGRATION_DATA_STATUS,
  GET_ALL_REGIONS,
  GET_ALL_MARKET_PLACES,
  GET_DOWNLOAD_FILE,
  GET_USER_RETURN_CALENDAR_TABLE,
  GET_NOTIFICATIONS,

  GET_ADMIN_RATES,
  GET_ADMIN_VAT_RATES,
  GET_ADMIN_RECEIVED_FILES,
  GET_ADMIN_IMPORTED_FILES,
  GET_ADMIN_EXPORTED_FILES,
  GET_ADMIN_IMPORT_FILE_STATUS,
  GET_ADMIN_IMPORT_FILE,
  GET_ADMIN_FILES_RETURN_TABLE,
  GET_ADMIN_RETURNS_FOR_PERIOD,
  POST_ADMIN_VAT_RATES,
  POST_ADMIN_FILE_UPLOAD,
  POST_ADMIN_IMPORT_FILE_STATE_ACTION,
  

  POST_ADMIN_CURRENT_COMPANY,
  POST_USER_REGISTER_TYPE_ONE,
  POST_USER_REGISTER_TYPE_TWO,
  POST_USER_EMAIL_EXIST,
  POST_USER_LOGIN,
  POST_GET_INTEGRATIONS,
  POST_USER_NEW_PASS,
  POST_USER_NEW_EMAIL,

  POST_ADMIN_NEW_PASS,
  POST_ADMIN_NEW_EMAIL,

  POST_VAT_PERIOD,
  POST_ME,
  POST_ME_ADMIN,
  POST_CONTACT_US,
  POST_USER_FILES_RETURN_TABLE,
  POST_VAT_NUMBER_ID,
  POST_NOTIFICATIONS_SEEN,
  POST_TRESHOLD_ORDERS,
  POST_NOTIFICATIONS_ALL_READ,

  CONTINENTS,
  FORM_FIELDS_USER_ONE,
  FORM_FIELDS_USER_TWO,
  FORM_FIELDS_INTEGRATION_AMAZON,

  CURRENCY_SELECT,
  MINIMUM_PASSWORD_LENGTH,
  MAXIMUM_PASSWORD_LENGTH,
  FAKE_PROVIDERS,
  FAKE_INTEGRATION_DATA,
  FAKE_USER_VAT_REGISTRATIONS_DATA,
  filterSalesTypeValues,
  filterBusinessTypeValues,
  filterRegionTypeValues,
  DAY_SELECT,
  FILTER_COUNTRY_SELECTION,
  FILTER_COUNTRY_SALES_DETALIZATION,
  DASHBOARD_MENU,
  ADMIN_MENU,
  USER_MENU_ITEMS,

  SALES_DETALIZATION_COLUMNS,
};
